<script lang="ts" setup>
defineProps({
  isMainSection: {
    default: false,
    type: Boolean,
  },
  trophies: {
    default: true,
    type: Boolean,
  },
})

const { t } = useI18n()
</script>

<template>
  <LayoutSection>
    <template #left>
      <BaseHeading
        :description="t('description')"
        :has-glow="!isMainSection"
        size="lg"
        :tag="isMainSection ? 'h1' : 'h2'"
        :title="t('title')"
      />
    </template>

    <template #right>
      <SubscriptionPlans class="mx-auto mb-20 max-w-6xl" />

      <ProductTrophies v-if="trophies" />
    </template>
  </LayoutSection>
</template>

<i18n lang="json">
{
  "en": {
    "description": "Join thousands of companies using our data to enhance products, workflows, and CRMs.",
    "title": "An enrichment API with affordable plans"
  },
  "es": {
    "description": "Únete a miles de empresas que utilizan nuestros datos para mejorar productos, workflows y CRMs.",
    "title": "Una API de enriquecimiento con planes accesibles"
  },
  "fr": {
    "description": "Rejoignez des milliers d'entreprises qui utilisent nos données pour améliorer leurs produits, workflows et CRMs.",
    "title": "Une API d'enrichissement avec des plans abordables"
  }
}
</i18n>
